import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";

function CustomConfirmation({
  openDelete,
  setOpenDelete,
  handleAgree,
  title,
  open,
  setOpen,
  renderElement = null,
  closeButtonText = null,
  closeButtonAction = null,
  buttonText = null,
  width = "",
  showCloseIcon = false,
  isForceAction = false,
}) {
  const [buttonLoading, setButtonLoading] = useState(false);
  const handleCloseDialog = () => {
    setOpenDelete(false);
  };
  const handleCloseDialog1 = () => {
    if (closeButtonAction) {
      closeButtonAction();
    } else {
      setOpen(false);
    }
  };

  const handleAgreeFunction = async () => {
    setButtonLoading(true);
    await handleAgree();
    setButtonLoading(false);
  };

  useEffect(() => {
    if (open || openDelete) {
      setButtonLoading(false);
    }
  }, [open, openDelete]);

  return (
    <>
      <Dialog
        open={openDelete ? openDelete : false}
        onClose={handleCloseDialog}
        PaperProps={{
          style: {
            backgroundColor: "white",
            color: "black",
            boxShadow: "none",
          },
        }}
      >
        <DialogTitle>
          {title ? title : "Are you sure you want to take this action?"}
        </DialogTitle>
        <DialogActions>
          <Button className="model-button-hover" onClick={handleCloseDialog}>
            Cancel
          </Button>
          <Button className="model-button-hover" onClick={handleAgree}>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
      {/* New to solve delete issue  */}
      <Dialog
        open={open ? open : false}
        onClose={() => !isForceAction && setOpen(false)}
        PaperProps={{
          style: {
            backgroundColor: "white",
            color: "black",
            boxShadow: "none",
          },
        }}
        fullWidth={width !== ""}
        maxWidth={width || "sm"}
      >
        <DialogTitle>
          <div className="d-flex align-items-start justify-content-between gap-2">
            {title ? title : "Are you sure you want to take this action?"}
            {showCloseIcon && (
              <IconButton onClick={() => setOpen(false)}>
                <CloseIcon />
              </IconButton>
            )}
          </div>
        </DialogTitle>
        {renderElement ? (
          <>
            <DialogContent>{renderElement}</DialogContent>
          </>
        ) : (
          ""
        )}
        <DialogActions>
          <Button className="model-button-hover" onClick={handleCloseDialog1}>
            {closeButtonText || "Cancel"}
          </Button>
          <LoadingButton
            className="model-button-hover"
            onClick={() => handleAgreeFunction()}
            loading={buttonLoading}
          >
            {buttonText || "Agree"}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CustomConfirmation;
